exports = module.exports = require("../../../../../../table-showoff/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".QuestionMark__ImageContainer__1htWn {\n  width: 100%;\n}\n\n.QuestionMark__ImageContainer__1htWn img {\n  width: 100%;\n  border-radius: 50%;\n}", ""]);

// exports
exports.locals = {
	"ImageContainer": "QuestionMark__ImageContainer__1htWn"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/components/UI/Thumbs/QuestionMark/QuestionMark.css
// module id = 452
// module chunks = 0